<template>
  <div />
</template>

<script>
import { getCacheConfig } from '@/utils'
import { getRewardType } from '@/api/config/slot'
import { getBuildBoxAllCfg } from '@/api/config/blind-box-cfg'
import { getAnimalAllList, getShieldsAllList, getSieveAllList } from '@/api/config/area-cfg'
import { getChestCfgAll } from '@/api/config/chest-skin-cfg'
import { getAvatarCfgAll } from '@/api/config/avatar-cfg'
import { getActivityTypeToMap } from '@/api/config/activity-cfg'

export default {
  name: 'InitReward',
  data() {
    return {
      ucType: 1
    }
  },
  created() {
    this.initConfig()
  },
  methods: {
    initConfig() {
      getCacheConfig(getRewardType, 'getRewardType' + this.ucType, { data: this.ucType }).then(res => {
      })
      getCacheConfig(getBuildBoxAllCfg, 'getBuildBoxAllCfg').then(res => {
      })
      getCacheConfig(getAnimalAllList, 'getAnimalAllList').then(res => { })
      getCacheConfig(getShieldsAllList, 'getShieldsAllList').then(res => { })
      getCacheConfig(getSieveAllList, 'getDiceAllList').then(res => { })
      getCacheConfig(getChestCfgAll, 'getChestCfgAll').then(res => {})
      getCacheConfig(getAvatarCfgAll, 'getAvatarCfgAll').then(res => {})
      getCacheConfig(getActivityTypeToMap, 'getActivityTypeToMap').then(res => {})
    }
  }
}
</script>

<style scoped>

</style>
